/*
 *
 *  RequireAuth.tsx
 *
 *
 *  Created by Nick Perry on 8/18/22
 *
 *  dha-login
 *
 *  Copyright © 2009-2023 United States Government as represented by
 *  the Program Manager of the DHA: Web and Mobile Technology Program Management Office
 *  All Rights Reserved.
 *
 *  Copyright © 2009-2023 Contributors. All Rights Reserved.
 *
 *  THIS OPEN SOURCE AGREEMENT ("AGREEMENT") DEFINES THE RIGHTS OF USE,
 *  REPRODUCTION, DISTRIBUTION, MODIFICATION AND REDISTRIBUTION OF CERTAIN
 *  COMPUTER SOFTWARE ORIGINALLY RELEASED BY THE UNITED STATES GOVERNMENT
 *  AS REPRESENTED BY THE GOVERNMENT AGENCY LISTED BELOW ("GOVERNMENT AGENCY").
 *  THE UNITED STATES GOVERNMENT, AS REPRESENTED BY GOVERNMENT AGENCY, IS AN
 *  INTENDED THIRD-PARTY BENEFICIARY OF ALL SUBSEQUENT DISTRIBUTIONS OR
 *  REDISTRIBUTIONS OF THE SUBJECT SOFTWARE. ANYONE WHO USES, REPRODUCES,
 *  DISTRIBUTES, MODIFIES OR REDISTRIBUTES THE SUBJECT SOFTWARE, AS DEFINED
 *  HEREIN, OR ANY PART THEREOF, IS, BY THAT ACTION, ACCEPTING IN FULL THE
 *  RESPONSIBILITIES AND OBLIGATIONS CONTAINED IN THIS AGREEMENT.
 *
 *  Government Agency: DHA: Web and Mobile Technology Program Management Office
 *  User Registration Requested. Please send email
 *  with your contact information to: robert.a.kayl.civ@mail.mil
 *  Government Agency Point of Contact for Original Software - Program Manager: robert.a.kayl.civ@mail.mil
 *
 */
import { useContext } from 'react';

import { Outlet } from 'react-router-dom';

import LoginController from '../controllers/LoginController';
import { AuthContext } from '../providers/AuthProvider';

/**
 * Wraps all routes that should only be accessed by an authenticated user.
 *
 * @example
 * ```javascript
 * <Routes>
 *   <Route element={<RequireAuth />}>
 *     <Route element={<Protected1 />} path="/protectedRoute1"/>
 *     <Route element={<Protected2 />} path="/protectedRoute2"/>
 *   </Route>
 * </Routes>
 * ```
 */
const RequireAuth = () => {
  const { authenticated } = useContext(AuthContext);

  if (!authenticated) {
    return <LoginController />;
  }

  return <Outlet />;
};

export default RequireAuth;
